<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row mb-12">
        <div class="col">
          <div class="page-title-nav row">
            <div class="col-2 col-lg-3">
              <router-link :to="`/member/home`" class="btn btn-outline-secondary btn-custom btn-back">
                <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                  class="d-none d-lg-block ms-2">ย้อนกลับ</span>
              </router-link>
            </div>
            <div class="col-8 col-lg-6">
              <h1 class="page-title">ผลรางวัลวันที่</h1>
            </div>
            <div class="col-12 col-lg-3">
              <!-- <label><i class="fas fa-calendar-alt"></i> วันที่เริ่ม</label> -->

              <!-- <v-date-picker v-model="selectDate" id="datePicker" /> -->
              <!-- <v-date-picker :max-date="new Date()" :masks="masks" :model-config="modelConfig" v-model.trim="$v.date.$model">
                  <div class="input-group date">
                    <div class="input-group input-group-sm input-group-merge">
                      <input :value="inputValue" v-on="inputEvents" type="text" class="form-control" placeholder="รหัสผู้ใช้งาน" readonly disabled  />
                      <span class="input-group-text"> <i class="fas fa-calendar my-0"></i></span>
                    </div>
                  </div>
              </v-date-picker> -->
              <!-- <a href="#" class="btn btn-primary btn-custom d-block"><i
                  class="fa-icon fa-regular fa-calendar"></i><span>เลือกวันที่</span></a> -->
            </div>
          </div>
          <div class="row justify-content-end mb-3">
            <div class="col-3">
              <!-- <input
    type="date"
    class="form-control bg-white"
    v-model="currentDate"
    :value="dateFormatted"
    @input="updateDate"
  /> -->
              <input id="startDate" class="form-control bg-white" type="date"  v-model="selectDate"/>
              <!-- <b-form-datepicker id="datepicker-dateformat2"
                :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }" locale="th"
                class="form-control datetimepicker-input mb-0" v-model="selectDate"
                placeholder="DD-MM-YYYY"></b-form-datepicker> -->
            </div>
            <!-- <div class="input-group-append" data-target="#datetimepicker4" data-toggle="datetimepicker">
                  <button class="btn btn-outline-secondary"><i class="fas fa-calendar my-0"></i></button>
                </div> -->
          </div>
          <div class="row">
            <div class="col-12 col-lg-4">
              <template v-if="getLottoResultAllList[0].filter(v => v.title == 'หวยรัฐบาล').length > 0">
                <app-mainResult v-bind:toDay="toDay(selectDate)"
                  v-bind:info="getLottoResultAllList[0].filter(v => v.title == 'หวยรัฐบาล')[0]"
                  v-if="getLottoResultAllList[0].filter(v => v.title == 'หวยรัฐบาล').length > 0" />
              </template>
              <template v-else>
                <div class="content-card">
                  <div class="content-card-title d-flex justify-content-between">
                    หวยรัฐบาล
                  </div>
                  <div data-v-52d507c5="" class="content-card-body p-0">
                    <div data-v-52d507c5="" class="empty-list"><i data-v-52d507c5=""
                        class="empty-state-icon icon-list"></i>
                      <h4 data-v-52d507c5="">ไม่มีข้อมูล</h4>
                    </div>
                  </div>
                </div>

              </template>
            </div>
            <div class="col-12 col-lg-8">
              <app-resultGroup :DateSelected="selectDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="push"></div>
    </div>
  </div>
</template>
<script>
import mainResult from '@/components/sakha/lotto/mainResult'
import resultGroup from '@/components/sakha/lotto/resultGroup'
import { format } from 'date-fns'
import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  components: {
    'app-mainResult': mainResult,
    'app-resultGroup': resultGroup

  },
  async created () {
    try {
      this.showOverlay = true
      this.setLoading(true)
      await Promise.all([
        this.getLottoResultAll('')
      ])
      this.setLoading(false)
      this.showOverlay = false
      this.lotteryInformation = this.getInquiryRoundInfomation
    } catch (error) {
      this.setLoading(false)
      this.showOverlay = false
    }
  },
  methods: {
    ...mapActions(['setLoading', 'getLottoResultAll']),
    toDay: (data) => {
      if (data === '') {
        return format(new Date(), 'dd MMMM yyyy')
      } else {
        return format(new Date(data), 'dd MMMM yyyy')
      }
    },
    formatDate () {
      // Format the date using dayjs when the date is selected
      if (this.selectDate) {
        this.formattedDate = dayjs(this.selectDate).format('DD/MM/YYYY')
      } else {
        this.formattedDate = '' // Clear if no date selected
      }
    },
    openDatePicker () {
      // Open the hidden date input when the button is clicked
      this.$refs.hiddenDateInput.click()
    },
    handleDateChange (event) {
      // When the date is selected, update both selectedDate and formattedDate
      this.selectedDate = event.target.value
      this.formattedDate = dayjs(this.selectedDate).format('DD/MM/YYYY')
    },
    updateDate (event) {
      const date = new Date(event.target.value)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      this.currentDate = `${year}-${month}-${day}`
    }
  },
  computed: {
    ...mapGetters(['getLottoResultAllList', 'getInquiryRoundInfomation']),
    dateFormatted () {
      if (!this.selectDate) return ''
      const [year, month, day] = this.selectDate.split('-')
      return `${day}/${month}/${year}`
    }
  },
  data: () => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    return {
      selectDate: `${year}-${month}-${day}`, // Format: YYYY-MM-DD
      formattedDate: '', // The date in DD/MM/YYYY format,
      // selectDate: '',
      showOverlay: true,
      lotteryInformation: null
    }
  },
  watch: {
    selectDate: function (val) {
      this.showOverlay = true
      this.getLottoResultAll(val)
    },
    getLottoResultAllList: function (val) {
      if (this.showOverlay === true) {
        this.showOverlay = false
      }
    }
  }
}
</script>
<style lang="less">
.btn-block {
  display: block !important;
  width: 100% !important;
}
</style>
